module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/athor25-5c9a684c6bf1336a379123b1521becdf.jpg";